var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSave = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85854 0.414673H1.57338C0.899508 0.414673 0.359192 0.96106 0.359192 1.62887V10.1282C0.359192 10.796 0.899508 11.3424 1.57338 11.3424H10.0727C10.7405 11.3424 11.2869 10.796 11.2869 10.1282V2.84306L8.85854 0.414673ZM10.0727 10.1282H1.57338V1.62887H8.35465L10.0727 3.34695V10.1282ZM5.82306 5.87854C4.81528 5.87854 4.00177 6.69205 4.00177 7.69983C4.00177 8.70761 4.81528 9.52112 5.82306 9.52112C6.83084 9.52112 7.64435 8.70761 7.64435 7.69983C7.64435 6.69205 6.83084 5.87854 5.82306 5.87854ZM2.18048 2.23596H7.64435V4.66435H2.18048V2.23596Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/save.867d2c4d.svg";
export { ForwardRef as ReactComponent };